module.exports = __webpack_public_path__ + "static/media/igo.ce923756.svg";